var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_403"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_403",
    "data-name": 403,
    className: "cls-2",
    d: "M63.64,93.6l-.22.19c-12.16,10.41-32.55-.38-39-13.34-6.88-13.89-.07-29.86,3.71-38.73C38,18.68,60.7-2.78,71.6,3.14c10.28,5.58,6.88,33.77,4.49,53.61C74.63,68.81,73,85.36,63.64,93.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog403);
export default __webpack_public_path__ + "static/media/dog_403.92a0446ba65c67de93d52f449741d7ee.svg";
export { ForwardRef as ReactComponent };